import { TipoTag, PerfilDoUsuario } from './enum';

export class TagGi {
  id: number;
  tag: string;
  icone: string;
  cor: string;
  tipo: number;
  somenteApi: boolean;
  disabled: boolean;
  tipoVinculo: number;
  dataHora?: Date;
  perfil?: PerfilDoUsuario;
  nomeUsuario?: string;
  nomeFuncionario?: string;
  nomeIntegrador?: string;
}
